import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: 400,
    height: 200,
    background: 'rgb(254, 252, 241)',
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    marginBottom: '-16px',
    marginLeft: '-5px',
  },
  contentContainer: {
    textAlign: 'center',
    padding: 10,
  },
}));

// Right now only the results pending is communicated to the user
const TwnMessagePanel = () => {
  const classes = useStyles();
  const title = 'Results Pending';
  const message1 = 'We are still gathering some or all of your truaccounts.';
  const message2 = 'Please note that we will notify you once these truaccounts are ready.';
  return (
    <div className={classes.mainContainer}>
      <div className={classes.contentContainer}>
        <img src="/icons/trustate_pending_icon.svg" alt="pending-icon" />
        <Typography variant="h5" color="primary">
          {title}
        </Typography>
        <Typography variant="body2">
          {message1} {message2}
        </Typography>
      </div>
    </div>
  );
};

export default TwnMessagePanel;
